export const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

export function normalizeCuts(cuts, duration) {
  const sorted = cuts
    .map(cut => ({ start: clamp(Number(cut.start), 0, duration), end: clamp(Number(cut.end), 0, duration) }))
    .filter(cut => Number.isFinite(cut.start) && Number.isFinite(cut.end) && cut.end - cut.start > 0.0001)
    .sort((a, b) => a.start - b.start);
  return sorted.reduce((result, cut) => {
    const previous = result[result.length - 1];
    if (previous && cut.start <= previous.end) previous.end = Math.max(previous.end, cut.end);
    else result.push({ ...cut });
    return result;
  }, []);
}

export function retainedIntervals(cuts, duration) {
  let cursor = 0;
  const intervals = [];
  for (const cut of normalizeCuts(cuts, duration)) {
    if (cut.start > cursor) intervals.push({ start: cursor, end: cut.start });
    cursor = cut.end;
  }
  if (cursor < duration) intervals.push({ start: cursor, end: duration });
  return intervals;
}

export function editedDuration(cuts, duration) {
  return retainedIntervals(cuts, duration).reduce((sum, interval) => sum + interval.end - interval.start, 0);
}

export function isRemoved(word, cuts, duration) {
  return !retainedIntervals(cuts, duration).some(part => word.start < part.end && word.end > part.start);
}

export function sourceToEdited(time, intervals, activeId) {
  const active = intervals.find(interval => interval.id === activeId);
  if (active && time >= active.start && time <= active.end) {
    return intervals.slice(0, intervals.indexOf(active)).reduce((sum, part) => sum + part.end - part.start, 0) + time - active.start;
  }
  let position = 0;
  let next = null;
  let last = null;
  for (const interval of intervals) {
    if (time >= interval.start && time < interval.end) return position + time - interval.start;
    if (time < interval.start && (!next || interval.start < next.start)) next = {start: interval.start, position};
    position += interval.end - interval.start;
    if (!last || interval.end > last.end) last = {end: interval.end, position};
  }
  return next?.position ?? last?.position ?? 0;
}

export function editedToSource(time, intervals) {
  let remaining = Math.max(0, time);
  for (const interval of intervals) {
    const length = interval.end - interval.start;
    // At a cut, select the first frame of the following retained section.
    if (remaining < length) return interval.start + remaining;
    remaining -= length;
  }
  return intervals.at(-1)?.end ?? 0;
}

export function formatTime(seconds) {
  const total = Math.max(0, Math.floor(seconds));
  return `${String(Math.floor(total / 60)).padStart(2, '0')}:${String(total % 60).padStart(2, '0')}`;
}

